import { Accordion, AccordionVariant } from '@aus-platform/design-system';
import React, { useState } from 'react';
import { useOrganisationLabels } from 'shared/api';
import { SectionHeader } from 'shared/components';
import { ITERATION_LABELS_ACCORDION_KEY } from './constants';
import { IterationLabelsAccordion } from './iteration-labels-accordion';
import { type IterationLabelsEditProps } from './types';

export const IterationLabelsEdit: React.FC<IterationLabelsEditProps> = ({
  onNavigateBack,
}) => {
  // Apis.
  const { data: labelsResponse, isLoading } = useOrganisationLabels();

  // States.
  const [activeAccordionKey, setActiveAccordionKey] = useState<
    string | undefined
  >(ITERATION_LABELS_ACCORDION_KEY);

  // Handlers.
  const toggleAccordion = () => {
    setActiveAccordionKey((currentKey) =>
      currentKey === ITERATION_LABELS_ACCORDION_KEY
        ? undefined
        : ITERATION_LABELS_ACCORDION_KEY,
    );
  };

  // Variables.
  const entries = labelsResponse?.data?.labels ?? [];

  return (
    <div className="settings-content">
      <div className="settings-content__body iteration-labels">
        <SectionHeader
          backLabel="Labels"
          description="Manage custom labels used when adding or editing iterations."
          onBack={onNavigateBack}
        />

        <div className="iteration-labels__accordions">
          <Accordion
            activeKey={activeAccordionKey}
            variant={AccordionVariant.ChevronRight}
          >
            <IterationLabelsAccordion
              entries={entries}
              isLoading={isLoading}
              isAccordionActive={
                activeAccordionKey === ITERATION_LABELS_ACCORDION_KEY
              }
              onToggleAccordionItem={toggleAccordion}
            />
          </Accordion>
        </div>
      </div>
    </div>
  );
};
